var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardBody, CardFooter, CardHeader, Heading, Text } from '@chakra-ui/react';
import { Icon } from '../Icon';
export const ToolCard = (_a) => {
    var { buttonProps, buttonText, description, icon, onClick, title } = _a, rest = __rest(_a, ["buttonProps", "buttonText", "description", "icon", "onClick", "title"]);
    return (_jsxs(Card, Object.assign({ _hover: {
            shadow: 'lg',
            transform: 'translateY(-4px)'
        }, color: 'darkBrandBlue.100', transition: 'all 0.2s', userSelect: 'none', w: '100%' }, rest, { children: [_jsxs(CardHeader, { children: [_jsx(Icon, { mb: '2.5', name: icon, opacity: '0.5', p: '0', size: '44px', strokeWidth: '0.8' }), _jsx(Heading, Object.assign({ size: 'sm' }, { children: title }))] }), _jsx(CardBody, Object.assign({ pt: '0' }, { children: _jsx(Text, Object.assign({ opacity: '0.7' }, { children: description })) })), _jsx(CardFooter, { children: _jsx(Button, Object.assign({}, buttonProps, { onClick: onClick, w: '100%' }, { children: buttonText })) })] })));
};
